import React from 'react';
import { Justify } from 'ksnm-common-ui/lib/Table2/Table.interface';
import { ORDER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';
import type { CellValue, ColumnInterface, DataSourceRow, RenderParam } from 'ksnm-common-ui/lib/Table2/Table.interface';

import { dataControlStore } from '@stores/dataControlStore';

import { Status } from '../Status';
import { ReportVersionCell } from './ReportVersionCell';

import styles from '../DataControl.module.scss';

const onClick = (data: DataSourceRow) => {
  const { addBreadcrumbs, addPage, lastPagesParam } = dataControlStore;

  addBreadcrumbs([data.step_num as string]);
  addPage([
    {
      controlType: 'stepLevel',
      execNum: data.exec_num as string,
      maxExecNum: lastPagesParam.maxExecNum,
      filters: [
        [
          {
            name: 'report_package_code_cm',
            type: FILTER.EQ,
            values: [data.report_package_code_cm as string],
            filterIsInverted: false,
          },
          {
            name: 'ctrl_vers',
            type: FILTER.EQ,
            values: [data.ctrl_vers as string],
            filterIsInverted: false,
          },
          {
            name: 'step_num',
            type: FILTER.EQ,
            values: [data.step_num as string],
            filterIsInverted: false,
          },
          {
            name: 'exec_num',
            type: FILTER.EQ,
            values: [data.exec_num as string],
            filterIsInverted: false,
          },
        ],
      ],
    },
  ]);
};

export const getColumns = (premiseData: { step_num: string; res_text: string }[]): ColumnInterface[] => [
  {
    title: 'Номер шага',
    key: 'step_code_ext',
    width: 130,
    orderBy: {
      type: ORDER.ASC,
      order: 1,
      isNullsFirst: false,
    },
  },
  {
    title: 'Наименование шага',
    key: 'step_name',
    width: 200,
    render: ({ data, value }) => (
      <Tooltip content={data.step_desc} hideOnClick={false}>
        <span>{value ?? ''}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Тип контроля',
    key: 'step_type',
    width: 200,
  },
  {
    title: 'Сравниваемые отчеты (левая сторона формулы)',
    key: 'reports_l_text',
    width: 350,
    render: ({ value, data }): JSX.Element | CellValue => {
      if (Array.isArray(data.reports_l)) {
        return (
          <>
            {data.reports_l.map((item, idx) => (
              <>
                <ReportVersionCell key={idx} dataRow={item} content={item.report_text}>
                  <span className={styles.link}>{item.report_code_ext}</span>
                </ReportVersionCell>
                {Array.isArray(data.reports_l) && idx != data.reports_l.length - 1 ? ', ' : ''}
              </>
            ))}
          </>
        );
      }

      return value;
    },
  },
  {
    title: 'Сравниваемые отчеты (правая сторона формулы)',
    key: 'reports_r_text',
    width: 350,
    render: ({ value, data }): JSX.Element | CellValue => {
      if (Array.isArray(data.reports_r)) {
        return (
          <>
            {data.reports_r.map((item, idx) => (
              <>
                <ReportVersionCell key={idx} dataRow={item} content={item.report_text}>
                  <span className={styles.link}>{item.report_code_ext}</span>
                </ReportVersionCell>
                {Array.isArray(data.reports_r) && idx != data.reports_r.length - 1 ? ', ' : ''}
              </>
            ))}
          </>
        );
      }

      return value;
    },
  },
  {
    title: 'Результат вычисления',
    key: 'res_text',
    width: 250,
  },
  {
    title: 'Статус',
    key: 'status_out',
    width: 350,
    render: ({ value, data }: RenderParam): JSX.Element | CellValue => {
      const premiseResult = data.is_premise
        ? premiseData?.find((item) => item.step_num === data.step_num)?.res_text ?? ''
        : null;

      const tooltip = data.is_premise && (
        <Tooltip content={premiseResult} hideOnClick={false}>
          <span className={styles.iconP}>P</span>
        </Tooltip>
      );

      return (
        <Status status={data.status_type}>
          <div className={styles.row}>
            {data.status === 'C' || data.status === 'O' ? (
              <>{value}</>
            ) : (
              <div onClick={() => onClick(data)} className={styles.link} style={{ cursor: 'pointer' }}>
                {value}
              </div>
            )}
            {tooltip}
          </div>
        </Status>
      );
    },
  },
  {
    title: 'Описание результата',
    key: 'text_out',
    width: 350,
    justify: Justify.CENTER,
  },
  {
    title: 'Формула',
    key: 'formula',
    width: 300,
  },
  {
    key: 'report_package_code_cm',
    hidden: true,
  },
  {
    key: 'ctrl_vers',
    hidden: true,
  },
  {
    key: 'status',
    hidden: true,
  },
  {
    key: 'status_type',
    hidden: true,
  },
  {
    key: 'is_premise',
    hidden: true,
  },
  {
    key: 'exec_num',
    hidden: true,
  },
  {
    key: 'step_desc',
    hidden: true,
  },
  {
    key: 'step_num',
    hidden: true,
  },
  {
    key: 'reports_r',
    hidden: true,
  },
  {
    key: 'reports_l',
    hidden: true,
  },
];
